import FormRowState from "./FormRowState";
import FormInputRowMode from "./FormInputRowMode";
import FormConfig from "./FormConfig";

function DefaultConfiguredFormState(config: FormConfig): FormRowState[] {
  return config.formConfig.map((rowConfig): FormRowState => {
    const defaultValues = rowConfig.inputOptions.map((inputOption: FormInputRowMode) =>
      inputOption.optionVariant === "form" && inputOption.nestedFormConfig
        ? DefaultConfiguredFormState(inputOption.nestedFormConfig)
        : null
    );

    return {
      currentModeIndex: 0,
      currentModeStates: defaultValues,
      currentModeErrors: defaultValues.map(() => null),
    };
  });
}

export default DefaultConfiguredFormState;
